import React, { useState } from 'react';
import { Card, CardHeader, CardBody } from '@progress/kendo-react-layout';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { Chart, ChartCategoryAxis, ChartCategoryAxisItem, ChartLegend, ChartPlotArea, ChartSeries, ChartSeriesItem, ChartSeriesItemTooltip, ChartSeriesLabels, ChartTitle, ChartValueAxis, ChartValueAxisItem, ChartXAxis, ChartXAxisItem, ChartYAxis, ChartYAxisItem, SeriesType, TooltipContext } from '@progress/kendo-react-charts';
import { ITicketProps } from '../../types/Ticket/ITicket';
import { GameplanApi } from '../../redux/api/GameplanApi';
import { UserApi } from '../../redux/api/UserApi';
import { toDigital } from '../../utils/utils';
import { Button, ButtonGroup, DropDownButton } from '@progress/kendo-react-buttons';
import * as svg from '@progress/kendo-svg-icons';
import { SystemApi } from '../../redux/api/SystemApi';
import { isMobile } from 'react-device-detect';
import { SvgIcon } from '@progress/kendo-react-common';


const Progress: React.FC<ITicketProps> = (ticket) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const { data: profile } = UserApi.useGetUserProfileQuery();
    const { data: workstream } = GameplanApi.useGetTicketWorkstreamQuery({ ticketId: ticket.ID }, { skip: !ticket.ID || !ticket.Is_Workstream });
    const { data: projectWorkstream } = GameplanApi.useGetProjectWorkstreamQuery({ projectId: ticket.Project_Id, workstreamId: ticket.WorkstreamId }, { skip: !ticket.ID || !ticket.Is_Workstream });
    const { data: allocation } = GameplanApi.useGetTicketAllocationQuery({ ticketId: ticket.ID }, { skip: !ticket.ID || !ticket.Is_Workstream });
    const myAllocation = allocation?.find(a => a.Contact_Id === profile.Id);
    var numericDateNoYear = { day: 'numeric', month: 'numeric' } as Intl.DateTimeFormatOptions;
    const [selectedTab, setSelectedTab] = useState(0);
    const wsEndDate = new Date(workstream ? workstream.End_Dt + 'Z' : 0);
    ///wsEndDate = new Date();
    wsEndDate.setDate(wsEndDate.getDate() + 1);

    //current date without seconds and milliseconds
    let now = new Date()
    now.setSeconds(0, 0);
    //console.warn('workstream', workstream);

    const startDate = selectedIndex === 2 ? (projectWorkstream && projectWorkstream?.StartDt + 'Z') : (workstream && workstream?.Start_Dt + 'Z');
    const endDate = selectedIndex === 2 ? (projectWorkstream && projectWorkstream?.EndDt + 'Z') : (workstream && workstream?.End_Dt + 'Z');
    //wsEndDate.setDate(wsEndDate.getDate() + 1);
    //const { data: projectDaysTotal } = SystemApi.useGetWorkDaysQuery({ slaId: ticket?.SLA_Id, start: new Date(projectWorkstream && projectWorkstream?.StartDt + 'Z').toISOString().split('T')[0], end: new Date(projectWorkstream && projectWorkstream?.EndDt + 'Z').toISOString().split('T')[0] }, { skip: !workstream?.Start_Dt || !workstream?.End_Dt });
    const { data: workstreamDaysTotal } = SystemApi.useGetWorkDaysQuery({ slaId: ticket?.SLA_Id, start: new Date(startDate || 0).toISOString().split('T')[0], end: new Date(endDate || 0).toISOString().split('T')[0] }, { skip: !startDate || !endDate });
    const { data: workstreamDaysUsed } = SystemApi.useGetWorkDaysQuery({ slaId: ticket?.SLA_Id, start: new Date(startDate || 0).toISOString().split('T')[0], end: now.toISOString().split('T')[0] }, { skip: !workstream?.Start_Dt });

    const handleTabSelect = (e: any) => {
        setSelectedTab(e.selected);
    };

    const totalDays = workstreamDaysTotal?.filter(d => d.Work_Open).length

    //My Time
    const myWorkTime = (myAllocation?.Logged_Time || 0 + myAllocation?.Logged_NonBill_Time || 0) / 60.0
    const myWorkPercent = myWorkTime / (myAllocation?.Assigned_Mins / 60.0) * 100.0;
    const myHoursLeft = myAllocation?.Assigned_Mins - (myWorkTime * 60.0);

    //Ticket time
    const ticketWorkTime = (workstream?.Total_Time_Logged + workstream?.Total_NonBillTime_Logged) / 60.0;
    const ticketWorkPercent = ticketWorkTime / (workstream?.Effort_Mins / 60.0) * 100.0;
    const ticketHoursLeft = workstream?.Effort_Mins - (ticketWorkTime * 60.0);

    //Project time
    const projectWorkTime = (projectWorkstream?.Total_Time + projectWorkstream?.Total_NonBill_Time) / 60.0;
    const projectWorkPercent = projectWorkTime / (projectWorkstream?.Total_Effort / 60.0) * 100.0;
    const projectHoursLeft = projectWorkstream?.Total_Effort - (projectWorkTime * 60.0);

    const hoursLeft = selectedIndex === 0 ? myHoursLeft : selectedIndex === 2 ? projectHoursLeft : ticketHoursLeft;
    const workTime = selectedIndex === 0 ? myWorkTime : selectedIndex === 2 ? projectWorkTime : ticketWorkTime;
    const workPercent = selectedIndex === 0 ? myWorkPercent : selectedIndex === 2 ? projectWorkPercent : ticketWorkPercent;
    const maxHours = selectedIndex === 0 ? myAllocation?.Assigned_Mins / 60.0 : selectedIndex === 2 ? projectWorkstream?.Total_Effort / 60.0 : workstream?.Effort_Mins / 60.0;

    const calDaysLEft = Math.max(0, totalDays - (workstreamDaysUsed?.filter(d => d.Work_Open).length || 0)) //Math.floor((new Date(workstream?.End_Dt + 'Z').getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
    const calDaysIn = Math.min(totalDays, workstreamDaysUsed?.filter(d => d.Work_Open).length || 0) //Math.floor((new Date().getTime() - new Date(workstream?.Start_Dt + 'Z').getTime()) / (1000 * 60 * 60 * 24));
    const calPercent = calDaysIn / (workstreamDaysTotal ? workstreamDaysTotal?.filter(d => d.Work_Open).length : 1) * 100.0

    const chartData = [
        {
            type: isMobile ? 'column' : 'bar',
            name: `Calendar Time \n(${new Date(startDate).toLocaleDateString(navigator.language, numericDateNoYear)} - ${new Date(endDate).toLocaleDateString(navigator.language, numericDateNoYear)})`,
            values: [calDaysIn, null],
            // data: [{
            //     name: `Calendar Time \n(${new Date(startDate).toLocaleDateString(navigator.language, numericDateNoYear)} - ${new Date(endDate).toLocaleDateString(navigator.language, numericDateNoYear)})`,
            //     value: calDaysIn
            // }],
            color: '#92fcb3',
            label: calPercent.toFixed(1) + '%',
            axis: 'days',
        },
        {
            type: isMobile ? 'column' : 'bar',
            name: 'Work Time',
            values: [null, workTime],
            // data: [{ name: 'Work Time', value: workTime }],
            color: '#94e2fc',
            label: workPercent.toFixed(1) + '%',
            axis: 'hours',
        }
    ]

    const tableData = [
        { key: 'Start', value: new Date(startDate).toLocaleDateString() },
        { key: 'Due', value: new Date(endDate).toLocaleDateString() },
        { key: 'Days left', value: calDaysLEft.toString() },
        { key: `Hours ${hoursLeft || 0 >= 0 ? 'left' : 'over'}`, value: toDigital(hoursLeft || 0, true) },
        // { key: 'totalDays', value: totalDays?.toString() },
        // { key: 'calDaysIn', value: workstreamDaysTotal?.length.toString() },
    ];

    const getStartIcon = (view: number) => {

        switch (view) {
            case 0:
                return <SvgIcon icon={svg.userOutlineIcon} />
            case 1:
                return <SvgIcon icon={svg.chartBarClusteredIcon} />
            case 2:
                return <SvgIcon icon={svg.gaugeRadialIcon} />
            default:
                return null;
        }
    };

    const viewOptions = [
        { text: "My Progress", svgIcon: svg.userIcon },
        { text: `${profile?.Phrases.CallPhrase} Progress`, svgIcon: svg.chartBarClusteredIcon },
        { text: "Workstream Progress", svgIcon: svg.gaugeRadialIcon }
    ]

    if (!ticket?.WorkstreamId) return null;

    return (
        <div className='mt-2'>
            <Card>
                <CardHeader className='d-flex align-items-center justify-content-between'>
                    <div><img className='mr-2' width={20} src='./images/gameplan-dark.png' />{profile.Phrases.Workstream}: <b>{workstream?.Workstream_Name}</b></div>
                    <DropDownButton
                        text={viewOptions[selectedIndex].text}
                        items={viewOptions}
                        onItemClick={(e) => {
                            const selectedIndex = e.itemIndex;
                            setSelectedIndex(selectedIndex);
                        }}
                        startIcon={getStartIcon(selectedIndex)}
                        endIcon={<SvgIcon icon={svg.chevronDownIcon} />}
                    />
                </CardHeader>
                <CardBody>
                    <GampleanChart tableData={tableData} series={chartData} totalDays={totalDays} totalHours={maxHours} />
                </CardBody>
            </Card >
        </div>
    );
};

export default Progress;
export type GPChartProps = {
    series: any[];
    tableData: { key: string; value: string }[];
    totalDays?: number;
    totalHours?: number;
}

export const GampleanChart: React.FC<GPChartProps> = (props) => (
    <div className='row d-flex flex-wrap justify-content-between'>
        {/* props.totalHours={props.totalHours} - {props.totalDays} - {props.series[0].color} - {props.series[1].color} */}
        <div className='col-12 col-lg-9'>
            <Chart style={{ width: '100%', height: (isMobile ? '300px' : '160px') }} transitions={false} >
                <ChartLegend position='left' orientation='vertical' visible={false} />
                <ChartPlotArea margin={{ left: 0, right: 0, top: 0, bottom: 0 }} background='#ddd' />
                <ChartSeries >
                    <ChartValueAxis>
                        <ChartValueAxisItem name='days' labels={{ format: '{0} days', visible: true }} min={0} max={props.totalDays} majorUnit={Math.round(props.totalDays / 10)} majorGridLines={{ visible: true }} />
                        <ChartValueAxisItem name='hours' labels={{ format: '{0}hrs', visible: true }} min={0} max={props.totalHours} majorUnit={Math.round(props.totalHours / 10)} majorGridLines={{ visible: true }} />
                    </ChartValueAxis>
                    {props?.series.map((item, idx) => (
                        <ChartSeriesItem stack={true} key={idx} type={item.type} data={item.values} name={item.name} axis={item.axis} tooltip={{ visible: true }} color={item.color} gap={0.4} >
                            <ChartSeriesLabels position='insideBase' background='transparent' color='#000' visible={true} content={(e) => e.value ? item.label : ''} />
                            <ChartSeriesItemTooltip format="{0} hrs" visible={true} render={(e: TooltipContext) => {
                                return idx === 0
                                    ? <div style={{ fontSize: '12px' }}><b>{item.name}</b><br />{e.point.value.toFixed(1)} work days</div>
                                    : <div style={{ fontSize: '12px' }}><b>{item.name}</b><br />{toDigital(e.point.value * 60)} hours</div>
                            }} />
                        </ChartSeriesItem>
                    ))}
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem categories={props?.series.map(s => s.name)} startAngle={45} axisCrossingValue={[0, 2]} />
                    </ChartCategoryAxis>
                </ChartSeries>
            </Chart>

        </div>
        <div className='col-12 col-lg-3'>
            <table className='mt-4 w-100' style={{ borderCollapse: 'collapse', marginTop: '28px' }}>
                <tbody>
                    {props.tableData.map((row, index) => (
                        <tr key={index}>
                            <td className='col-6' style={{ fontWeight: 'bold', padding: '5px', backgroundColor: '#969595', color: '#fff' }}>{row.key}:</td>
                            <td className='col-6' style={{ padding: '5px', border: '1px solid #969595' }}>{row.value}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
);